import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_anutrav8rq: FaireBrandEntity = {
  token: "b_anutrav8rq",
  type: "brand",
  name: "Aromafume",
  avatarUrl:
    "https://cdn.faire.com/fastly/52d77642165b30a9b65115da338ec6ba83d5c0f76434457a3fd2abc179a97a80.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5683c010d4178f9d875213059bac1521494a453ea560ce4e34f17436237c608e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/52d77642165b30a9b65115da338ec6ba83d5c0f76434457a3fd2abc179a97a80.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5683c010d4178f9d875213059bac1521494a453ea560ce4e34f17436237c608e.png",
  location: "DE, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "Our family has been blending scents for over 100 years. It all began in 1907, in our grandmother’s kitchen in Aden, where we developed the art of blending essential oils, incense, and perfumes. In the 1970s, our family embarked on a journey across Africa, the Middle East, and Asia, tracing the ancient trade routes of spices, herbs, and resins through 43 countries. Inspired by the wisdom of aromatherapists, yogis, herbalists, reiki masters, and spiritual healers we encountered along the way, we honed the art of creating scents that elevate sacred spaces, homes, and personal wellbeing.\n\nToday, we offer eight unique collections that celebrate the world’s most powerful scent rituals — each crafted with artisanal recipes, nature’s finest ingredients, and the richness of diverse cultures. As we grow, so does our mission: to share more stories of scent, culture, and conscious living.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:28.693Z",
    importedBy: "entity-db-cli",
  },
};
